import _Translator from "utils/translator";

const initCollection = (holderSelector, addText, startWithEmptyRow = true) => {
    _Translator.loadTranslations.then(Translator => {
        const $addLink = $(
            `<a href="#" class="add_md_link btn btn-sm btn-default"><span class="tapicon tapicon-add"></span> ${addText ||
                Translator.trans("cta.add")}</a>`,
        );
        const $newLinkDiv = $("<div></div>").append($addLink);

        var $collectionHolder = $(holderSelector);
        if (!$collectionHolder) return;

        $collectionHolder.find("div.row").each(function() {
            addRowDeleteLink($(this));
        });

        $collectionHolder.append($newLinkDiv);
        $collectionHolder.data("index", $collectionHolder.find(":input").length);

        $addLink.on("click", function(e) {
            e.preventDefault();
            addRow($collectionHolder, $newLinkDiv);
        });

        function addRow($collectionHolder, $newLinkDiv) {
            if ($collectionHolder.find(".row").length >= 20) {
                import("flash-message").then(showFlash => showFlash.default("warning", "A maximum of 20 is allowed"));
                return;
            }

            var prototype = $collectionHolder.data("prototype");
            var index = $collectionHolder.data("index");
            var newForm = prototype.replace(/__name__/g, index);
            $collectionHolder.data("index", index + 1);
            var $newFormDiv = $(newForm);
            addRowDeleteLink($newFormDiv);
            $newLinkDiv.before($newFormDiv);
        }

        function addRowDeleteLink($formDiv) {
            var $removeFormA = $('<a href="#"><span class="tapicon tapicon-delete"></span></a>');
            $formDiv.find(".remove-holder").append($removeFormA);

            $removeFormA.on("click", function(e) {
                e.preventDefault();
                $formDiv.remove();
            });
        }

        if (startWithEmptyRow && $collectionHolder.find(".row").length === 0) addRow($collectionHolder, $newLinkDiv);
    });
};

module.exports.initCollection = initCollection;
